import script from "./Step2SetOrganization.vue?vue&type=script&setup=true&lang=js"
export * from "./Step2SetOrganization.vue?vue&type=script&setup=true&lang=js"

import "./Step2SetOrganization.vue?vue&type=style&index=0&id=965951ca&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-965951ca"]])

export default __exports__